export default __webpack_public_path__ + "32510d18d4306d1e4f03df4bad3e8549.svg";